import { IFireNotification } from '../../../components/NotificationComponent';

enum TypeKeys {
    CAPABILITIES_LOADED = 'CAPABILITIES_LOADED',
    CUSTOM_EVENT = 'CUSTOM_EVENT',
    DATA_LOADED = 'DATA_LOADED',
    ERROR_LOADING_DATA = 'ERROR_LOADING_DATA',
    ERROR_LOADING_TEMPLATE = 'ERROR_LOADING_TEMPLATE',
    INITIALIZE_WIDGET = 'INITIALIZE_WIDGET',
    LOADING_DATA = 'LOADING_DATA',
    LOADED_PERSISTED_STATE = 'LOADED_PERSISTED_STATE',
    LOADING_TEMPLATE = 'LOADING_TEMPLATE',
    NOTIFICATION_DISMISSED = 'NOTIFICATION_DISMISSED',
    SET_REPORT_LOCATION = 'SET_REPORT_LOCATION',
    SET_REPORT_SITE = 'SET_REPORT_SITE',
    SET_REPORT_TIME = 'SET_REPORT_TIME',
    SET_TIME = 'SET_TIME',
    SET_TIME_FOR_ALL_WIDGET_BLOCKS = 'SET_TIME_FOR_ALL_WIDGET_BLOCKS',
    TEMPLATE_LOADED = 'TEMPLATE_LOADED',
    TIMER_SET_EVENT = 'TIMER_SET', // FIXME: This should be removed. Check with Troy.
}

interface WidgetBlockAction<K = string, T = any> {
    type: K;
    payload: {
        widgetId?: string | null;
        instanceId?: string | null;
    } & T;
}

interface FireActions {
    fireCustomEvent(eventName: string, payload?: any): void;
    fireNotificationDismissed: IFireNotification;
}

export { CustomEventAction } from './customEvent';
export { ErrorLoadingDataAction } from './errorFetchingWidgetData';
export { ErrorLoadingTemplateAction } from './errorFetchingWidgetTemplate';
export { InitializeWidgetAction } from './initializeWidget';
export { LoadedPersistedStateAction } from './loadedPersistedState';
export { LoadingDataAction } from './loadingWidgetData';
export { LoadingTemplateAction } from './loadingWidgetTemplate';
export { NotificationDismissedAction } from './notificationDismissed';
export { SetCapabilitiesLoadedAction } from './setCapabilitiesLoaded';
export { SetReportAction } from './setReportLocation';
export { ReportSiteAction } from './setReportSite';
export { ReportTimeAction } from './setReportTime';
export { SetTimeAction } from './setTime';
export { SetTimeForAllWidgetBlocksAction } from './setTimeForAllWidgetBlocks';
export { TimerSetAction } from './setTimerSet';
export { DataLoadedAction } from './widgetDataLoaded';
export { TemplateLoadedAction } from './widgetTemplateLoaded';
export { FireActions, TypeKeys, WidgetBlockAction };
